module.exports = __webpack_public_path__ + "static/media/m_w_hb_35.aeaa566f.png";